

const options = [{
      value: '140100',
      label: '太原市',
      children: [{
        value: '140105',
        label: '小店区'
      }, {
        value: '140106',
        label: '迎泽区'
      }, {
        value: '140107',
        label: '杏花岭区'
      }, {
        value: '140108',
        label: '尖草坪区'
      }, {
        value: '140109',
        label: '万柏林区'
      }, {
        value: '140110',
        label: '晋源区'
      }, {
        value: '140121',
        label: '清徐县'
      }, {
        value: '140122',
        label: '阳曲县'
      }, {
        value: '140123',
        label: '娄烦县'
      }, {
        value: '140181',
        label: '古交市'
      }]
    }, {
      value: '140200',
      label: '大同市',
      children: [{
        value: '140202',
        label: '城区'
      }, {
        value: '140203',
        label: '矿区'
      }, {
        value: '140211',
        label: '南郊区'
      }, {
        value: '140212',
        label: '新荣区'
      }, {
        value: '140221',
        label: '阳高县'
      }, {
        value: '140222',
        label: '天镇县'
      }, {
        value: '140223',
        label: '广灵县'
      }, {
        value: '140224',
        label: '灵丘县'
      }, {
        value: '140225',
        label: '浑源县'
      }, {
        value: '140226',
        label: '左云县'
      }, {
        value: '140227',
        label: '大同县'
      }]
    }, {
      value: '140300',
      label: '阳泉市',
      children: [{
        value: '140302',
        label: '城区'
      }, {
        value: '140303',
        label: '矿区'
      }, {
        value: '140311',
        label: '郊区'
      }, {
        value: '140321',
        label: '平定县'
      }, {
        value: '140322',
        label: '盂县'
      }]
    }, {
      value: '140400',
      label: '长治市',
      children: [{
        value: '140402',
        label: '城区'
      }, {
        value: '140411',
        label: '郊区'
      }, {
        value: '140421',
        label: '长治县'
      }, {
        value: '140423',
        label: '襄垣县'
      }, {
        value: '140424',
        label: '屯留县'
      }, {
        value: '140425',
        label: '平顺县'
      }, {
        value: '140426',
        label: '黎城县'
      }, {
        value: '140427',
        label: '壶关县'
      }, {
        value: '140428',
        label: '长子县'
      }, {
        value: '140429',
        label: '沁源县'
      }, {
        value: '140430',
        label: '沁县'
      }, {
        value: '140481',
        label: '潞城市'
      }]
    }, {
      value: '140500',
      label: '晋城市',
      children: [{
        value: '140502',
        label: '城区'
      }, {
        value: '140521',
        label: '沁水县'
      }, {
        value: '140522',
        label: '阳城县'
      }, {
        value: '140524',
        label: '陵川县'
      }, {
        value: '140525',
        label: '泽州县'
      }, {
        value: '140581',
        label: '高平市'
      }]
    }, {
      value: '140600',
      label: '朔州市',
      children: [{
        value: '140602',
        label: '朔城区'
      }, {
        value: '140603',
        label: '平鲁区'
      }, {
        value: '140621',
        label: '山阴县'
      }, {
        value: '140622',
        label: '应县'
      }, {
        value: '140623',
        label: '右玉县'
      }, {
        value: '140624',
        label: '怀仁县'
      }]
    }, {
      value: '140700',
      label: '晋中市',
      children: [{
        value: '140702',
        label: '榆次区'
      }, {
        value: '140721',
        label: '榆社县'
      }, {
        value: '140722',
        label: '左权县'
      }, {
        value: '140723',
        label: '和顺县'
      }, {
        value: '140724',
        label: '昔阳县'
      }, {
        value: '140725',
        label: '寿阳县'
      }, {
        value: '140726',
        label: '太谷县'
      }, {
        value: '140727',
        label: '祁县'
      }, {
        value: '140728',
        label: '平遥县'
      }, {
        value: '140729',
        label: '灵石县'
      }, {
        value: '140781',
        label: '介休市'
      }]
    }, {
      value: '140800',
      label: '运城市',
      children: [{
        value: '140802',
        label: '盐湖区'
      }, {
        value: '140821',
        label: '临猗县'
      }, {
        value: '140822',
        label: '万荣县'
      }, {
        value: '140823',
        label: '闻喜县'
      }, {
        value: '140824',
        label: '稷山县'
      }, {
        value: '140825',
        label: '新绛县'
      }, {
        value: '140826',
        label: '绛县'
      }, {
        value: '140827',
        label: '垣曲县'
      }, {
        value: '140828',
        label: '夏县'
      }, {
        value: '140829',
        label: '平陆县'
      }, {
        value: '140830',
        label: '芮城县'
      }, {
        value: '140881',
        label: '永济市'
      }, {
        value: '140882',
        label: '河津市'
      }]
    }, {
      value: '140900',
      label: '忻州市',
      children: [{
        value: '140902',
        label: '忻府区'
      }, {
        value: '140921',
        label: '定襄县'
      }, {
        value: '140922',
        label: '五台县'
      }, {
        value: '140923',
        label: '代县'
      }, {
        value: '140924',
        label: '繁峙县'
      }, {
        value: '140925',
        label: '宁武县'
      }, {
        value: '140926',
        label: '静乐县'
      }, {
        value: '140927',
        label: '神池县'
      }, {
        value: '140928',
        label: '五寨县'
      }, {
        value: '140929',
        label: '岢岚县'
      }, {
        value: '140930',
        label: '河曲县'
      }, {
        value: '140931',
        label: '保德县'
      }, {
        value: '140932',
        label: '偏关县'
      }, {
        value: '140981',
        label: '原平市'
      }]
    }, {
      value: '141000',
      label: '临汾市',
      children: [{
        value: '141002',
        label: '尧都区'
      }, {
        value: '141021',
        label: '曲沃县'
      }, {
        value: '141022',
        label: '翼城县'
      }, {
        value: '141023',
        label: '襄汾县'
      }, {
        value: '141024',
        label: '洪洞县'
      }, {
        value: '141025',
        label: '古县'
      }, {
        value: '141026',
        label: '安泽县'
      }, {
        value: '141027',
        label: '浮山县'
      }, {
        value: '141028',
        label: '吉县'
      }, {
        value: '141029',
        label: '乡宁县'
      }, {
        value: '141030',
        label: '大宁县'
      }, {
        value: '141031',
        label: '隰县'
      }, {
        value: '141032',
        label: '永和县'
      }, {
        value: '141033',
        label: '蒲县'
      }, {
        value: '141034',
        label: '汾西县'
      }, {
        value: '141081',
        label: '侯马市'
      }, {
        value: '141082',
        label: '霍州市'
      }]
    }, {
      value: '141100',
      label: '吕梁市',
      children: [{
        value: '141102',
        label: '离石区'
      }, {
        value: '141121',
        label: '文水县'
      }, {
        value: '141122',
        label: '交城县'
      }, {
        value: '141123',
        label: '兴县'
      }, {
        value: '141124',
        label: '临县'
      }, {
        value: '141125',
        label: '柳林县'
      }, {
        value: '141126',
        label: '石楼县'
      }, {
        value: '141127',
        label: '岚县'
      }, {
        value: '141128',
        label: '方山县'
      }, {
        value: '141129',
        label: '中阳县'
      }, {
        value: '141130',
        label: '交口县'
      }, {
        value: '141181',
        label: '孝义市'
      }, {
        value: '141182',
        label: '汾阳市'
      }]
    }];
  export default options